import React, { useState, useCallback, useEffect, useContext } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
// import { Helmet } from "react-helmet";
/* --------------------------------------------- */
import DetailsSection from '../DetailsSection'
import RailContainer from '../../containers/RailContainer'
import PurchaseRail from '../InAppPayment/PurchaseRail'
/* --------------------------------------------- */
import { GlobalContext } from '../../context/global.context'
// import PurchasePlaceholder from '../InAppPayment/PurchasePlaceholder'
/* --------------------------------------------- */
import utils from '../../utils/utils'
import { routeVarMap } from '../../route'
import { version } from '../../config'
/* --------------------------------------------- */
// DetailsPage component having logic for displaying details page.
const DetailsPage = ({ thisIsChannel, mediaId, movieSeriesId, appMessages, productList, revenueFeature, curentSeasonEpisodeNumber,
  catalogFeature, metaTheme, detailsSectionData, castConfigPlaybackFormat, previewAssetFormat,
  seasonData, curentSeason, baseUrl, handleCurrentSeasonChange, theme, dataLoading, isProductLoadingComplete, episodeProgress, mediaInfo
}) => {
  const params = useParams()
  const pageName = params.pageName || ''
  /* --------------------------------------------- */
  const [isEpisodeLoading, updateIsEpisodeLoading] = useState(params.type === routeVarMap.type.series ? true : false)
  const [isShowPurchaseRail, updateIsShowPurchaseRail] = useState(false)
  const [isProductLoading, updateIsProductLoading] = useState(detailsSectionData.purchaseMode !== 'free' ? true : false)
  const [identityProvider, setIdentityProvider] = useState('')
  /* --------------------------------------------- */
  const { pageComponent = {} } = useSelector(store => store.navigation)
  const { userManagementConfig = {} } = useSelector(store => store.userManagement)
  const { authConfig: userAuthConfig = [] } = userManagementConfig
  const { pagesNavigation = {} } = pageComponent
  /* --------------------------------------------- */
  const { dispatch } = useContext(GlobalContext)
  /* --------------------------------------------- */
  const location = useLocation()
  /* --------------------------------------------- */
  const handleApiEnd = useCallback(() => {
    updateIsEpisodeLoading(false)
  }, [])
  /* --------------------------------------------- */
  /**
   * It: Sets page title.
   */
  useEffect(() => {
    dispatch({ type: 'PAGE_TITLE', value: '' })
    return () => {
      dispatch({ type: 'PAGE_TITLE', value: '' })
    }
  }, [dispatch])
  /* --------------------------------------------- */
  /**
   * It: Sets identityProvider in a state
   */
  useEffect(() => {
    if (!userAuthConfig) return
    const authConfig = userAuthConfig[0] || {}
    const identityProvider = authConfig.identityProvider || ''
    setIdentityProvider(identityProvider)
  }, [userAuthConfig])
  /* --------------------------------------------- */
  /**
   * It: Shows purchase rail based on contentful config.
   */
  useEffect(() => {
    if (revenueFeature.revenueMode && (revenueFeature.revenueMode[0] === "tvod" || revenueFeature.revenueMode[0] === "svod")) {
      updateIsShowPurchaseRail(true)
    }
  }, [revenueFeature.revenueMode])
  /* --------------------------------------------- */
  /**
   * It: Sets state to identify product loading.
   */
  useEffect(() => {
    if (detailsSectionData.purchaseMode === 'free') {
      updateIsProductLoading(false)
    }
  }, [detailsSectionData.purchaseMode])
  /* --------------------------------------------- */
  /**
   * It: Sets state to identify product loading.
   */
  useEffect(() => {
    if (isProductLoadingComplete) {
      updateIsProductLoading(false)
    }
  }, [isProductLoadingComplete])
  /* --------------------------------------------- */
  /**
   * It: Show/hide back button.
   */
  useEffect(() => {
    if (!pagesNavigation) return

    const query = utils.parse(location.search)
    const identifierExt = query.identifierExt || ''

    if (utils.isNotNull(pagesNavigation, "details", identifierExt, 'menuStyle')) {
      const menuStyle = pagesNavigation.details[identifierExt].menuStyle
      if (menuStyle === 'BackButton') {
        dispatch({ type: 'SHOW_HEADER_BACK_BTN' })
      } else {
        dispatch({ type: 'HIDE_HEADER_BACK_BTN' })
      }
    } else {
      if (version.project === 'tap') {
        dispatch({ type: 'SHOW_HEADER_BACK_BTN' })
      } else {
        dispatch({ type: 'HIDE_HEADER_BACK_BTN' })
      }
    }
  }, [pagesNavigation, location.search, dispatch])
  /* --------------------------------------------- */
  return (
    <>
      <div className='catalogContainer'>
        <div className='details-page__content main-container'>
          <DetailsSection {...{
            ...detailsSectionData, castConfigPlaybackFormat, curentSeason,
            appMessages, mediaId, catalogFeature, metaTheme, movieSeriesId,
            seasonId: curentSeason, baseUrl, seasonData, handleCurrentSeasonChange, theme,
            dataLoading, isProductLoading, previewAssetFormat, thisIsChannel, identityProvider,
            isPurchasedProduct: productList.purchasedProducts && productList.purchasedProducts && productList.purchasedProducts.length,
            detailsSectionData, pageName, mediaInfo
          }} />
          {productList.products && productList.products.length && !productList.purchasedProducts.length
            && isShowPurchaseRail ? <PurchaseRail
              {...{
                mediaId,
                baseUrl,
                railTittle: appMessages.label_details_product_list_title,
                productList: productList.products,
                identityProvider
              }}
            /> : null}

          {/* {detailsSectionData.purchaseMode && detailsSectionData.purchaseMode !== 'free' && productList.length === 0 && revenueFeature.revenueMode && (revenueFeature.revenueMode[0] === "tvod" || revenueFeature.revenueMode[0] === "svod")
            && isShowPurchaseRail && !productList?.error ? <PurchasePlaceholder
              {...{
                railTittle: appMessages.label_details_product_list_title, identityProvider
              }}
            /> : null} */}
          {params.type === routeVarMap.type.series && <RailContainer {...{ dataLoading, curentSeason, curentSeasonEpisodeNumber, playbackProgress: episodeProgress, onApiEnd: handleApiEnd, mediaId, seriesId: movieSeriesId, detailsSectionData, identityProvider, pageName }} />}
          {(mediaInfo?.type !== 'live') ? <div id="recombee-rail" className={`${(dataLoading || (params.type === routeVarMap.type.series && curentSeason && isEpisodeLoading) || isProductLoading) ? 'd-none' : ''}`}>
            <RailContainer {...{ mediaId: movieSeriesId, detailsSectionData, dataLoading, identityProvider, pageName }} isRelatedRail />
          </div> : null}

          {productList.products && productList.purchasedProducts.length
            && isShowPurchaseRail ? <PurchaseRail
              {...{
                mediaId,
                baseUrl,
                appMessages,
                railTittle: appMessages.label_details_product_already_purchased_title,
                productList: productList.purchasedProducts,
                isPurchasedProduct: true,
                identityProvider
              }}
            /> : null}

          {productList.products && productList.products.length && productList.purchasedProducts.length
            && isShowPurchaseRail ? <PurchaseRail
              {...{
                mediaId,
                baseUrl,
                railTittle: appMessages.label_details_product_optional_purchase_title,
                productList: productList.products,
                identityProvider
              }}
            /> : null}

        </div>
      </div>
    </>
  )
}
/* --------------------------------------------- */
DetailsPage.propTypes = {
  /** prop from react router. */
  match: PropTypes.object,
  /** app config from contentful */
  appConfig: PropTypes.object,
  /** Page theme. */
  theme: PropTypes.object
}
/* --------------------------------------------- */
DetailsPage.defaultProps = {
  theme: {}
}

/* --------------------------------------------- */
export default DetailsPage
